import { useMemo } from 'react';

import { ApiSectionNamespace } from '@api';
import {
  useHttpClientAwaitable,
  httpMethods,
  EHttpClient,
  IGraphQLMutationObject,
  IHttpHookResponseAwaitable,
  GRAPHQL_HEADER,
} from '@services/httpClientService';

import { ILastOrder } from '../../../model';

import { VALIDATE_OALT_CART_MUTATION } from './graphql';
import { mappingFunctionCheckout, mapToCheckoutRequest } from './mapper';
import { ILastOrderValidatedCart, ILastOrderValidatedCartResponse, IValidateLastOrderCartRequest } from './model';

export const useValidateLastOrderCart = (): IHttpHookResponseAwaitable<ILastOrderValidatedCart, ILastOrder> => {
  const { request: checkoutClientRequest } = useHttpClientAwaitable<
    ILastOrderValidatedCart,
    IGraphQLMutationObject<IValidateLastOrderCartRequest>,
    ILastOrderValidatedCartResponse
  >({
    method: httpMethods.POST,
    path: ApiSectionNamespace.EOrderAsLastTimeApiKeys.ORDER_AS_LAST_TIME_VALIDATE_CART_URL,
    mappingFunction: mappingFunctionCheckout,
    httpClientType: EHttpClient.CHECKOUT_GATEWAY,
    customHeaders: GRAPHQL_HEADER,
  });

  return useMemo(() => {
    const checkoutRequest = (lastOrder?: ILastOrder) => {
      const payload = mapToCheckoutRequest(lastOrder);
      const data = { query: VALIDATE_OALT_CART_MUTATION, ...(payload && { variables: { payload } }) };
      return checkoutClientRequest({ data });
    };

    return { request: checkoutRequest };
  }, [checkoutClientRequest]);
};
